export function getKeysList<T extends object>(obj: T, omitList?: string[]) {
  if (!obj) {
    return [];
  }
  const keysList = Object.keys(obj);
  return omitList ? keysList.filter(key => !omitList.includes(key)) : keysList;
}
